import { render, staticRenderFns } from "./ResultsBox.vue?vue&type=template&id=93a819a8&scoped=true&"
import script from "./ResultsBox.vue?vue&type=script&lang=js&"
export * from "./ResultsBox.vue?vue&type=script&lang=js&"
import style0 from "./ResultsBox.vue?vue&type=style&index=0&id=93a819a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a819a8",
  null
  
)

export default component.exports